 
 
 
 
 
 
/**
 * @ignore
 * Store the list of geopolitical views available as key-value pairs.
 * By now each view is only compose by a code. A label was added to add more meaning to the code.
 * Using object values for each key allows us to easily expand the properties of the view if is needed.
 */
define([], function() {
    'use strict';
    return {
        Unified: {
            label: 'Unified'
        },
        IN: {
            label: 'India'
        },
        IL: {
            label: 'Israel'
        }
    };
});



// WEBPACK FOOTER //
// ./config/geopolView/geopolViewsMapping.js